module.exports = __webpack_public_path__ + "static/media/clean-system-end.301e7d73.jpg";